import { createApp } from "vue";
import App from "./App.vue";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";

createApp(App).mount("#app");